document.addEventListener('DOMContentLoaded', () => {
  interface FormValue {
    [key: string]: string | number;
  }
  var formValue: FormValue = {
    AdultsWorking: '0',
    AdultsRetired: '0',
    Children: '0',
    NumberOfApplicants: 1,
    NetIncomeApplicant1PY: '0',
    NetIncomeApplicant2PY: '0',
    NetIncomeApplicant3PY: '0',
    NetIncomeApplicant4PY: '0',
    GrossIncomeApplicant1PY: '0',
    GrossIncomeApplicant2PY: '0',
    GrossIncomeApplicant3PY: '0',
    GrossIncomeApplicant4PY: '0',
    HouseholdExpenditurePY: '0',
    MortgageTerm: '40',
    PropertyPurchasePrice: '0',
    MortgageAmount: '0',
    RepaymentType: '0',
    TotalIncomePerYear: '0',
    MonthlyDispensibleIncome: '0',
    LoanToValue: '0',
    PersonsExpenditurePM: '0',
    IncomeMultiple: '0',
    creditCommitmentsPY: '0',
    PropertyType: '0',
    energyCostsPY: '0',
  };

  //ONS Data
  let oneAR = '420.31';
  let twoAR = '755.72';
  let oneA = '395.65';
  let twoA = '811.06';
  let oneAoneC = '479.79';
  let oneAtwoC = '606.29';
  let twoAoneC = '859.53';
  let twoAtwoC = '1000.64';
  let twoAthreeC = '1054.23';
  let threeA = '1228.46';
  let threeAoneC = '1205.42';

  //Energy Costs
  let onsdetached = '217.25';
  let onssemi = '174.59';
  let onsend = '161.16';
  let onsmid = '154.84';
  let onsbungalow = '161.16';
  let onsflat = '128.77';
  interface FamilyGroups {
    [key: string]: string | number;
  }
  const familyGroups: FamilyGroups = {
    '0AW1AR0C': oneAR,
    '0AW1AR1C': oneAoneC,
    '0AW1AR2C': oneAtwoC,
    '0AW1AR3C': oneAtwoC,
    '0AW2AR0C': twoAR,
    '0AW2AR1C': twoAoneC,
    '0AW2AR2C': twoAtwoC,
    '0AW2AR3C': twoAthreeC,
    '0AW3AR0C': threeA,
    '0AW3AR1C': threeAoneC,
    '0AW3AR2C': threeAoneC,
    '0AW3AR3C': threeAoneC,

    '1AW0AR0C': oneA,
    '1AW0AR1C': oneAoneC,
    '1AW0AR2C': oneAtwoC,
    '1AW0AR3C': oneAtwoC,
    '1AW1AR0C': twoA,
    '1AW1AR1C': twoAoneC,
    '1AW1AR2C': twoAtwoC,
    '1AW1AR3C': twoAthreeC,
    '1AW2AR0C': threeA,
    '1AW2AR1C': threeAoneC,
    '1AW2AR2C': threeAoneC,
    '1AW2AR3C': threeAoneC,
    '1AW3AR0C': threeA,
    '1AW3AR1C': threeAoneC,
    '1AW3AR2C': threeAoneC,
    '1AW3AR3C': threeAoneC,

    '2AW0AR0C': twoA,
    '2AW0AR1C': twoAoneC,
    '2AW0AR2C': twoAtwoC,
    '2AW0AR3C': twoAthreeC,
    '2AW1AR0C': threeA,
    '2AW1AR1C': threeAoneC,
    '2AW1AR2C': threeAoneC,
    '2AW1AR3C': threeAoneC,
    '2AW2AR0C': threeA,
    '2AW2AR1C': threeAoneC,
    '2AW2AR2C': threeAoneC,
    '2AW2AR3C': threeAoneC,
    '2AW3AR0C': threeA,
    '2AW3AR1C': threeAoneC,
    '2AW3AR2C': threeAoneC,
    '2AW3AR3C': threeAoneC,

    '3AW0AR0C': threeA,
    '3AW0AR1C': threeAoneC,
    '3AW0AR2C': threeAoneC,
    '3AW0AR3C': threeAoneC,
    '3AW1AR0C': threeA,
    '3AW1AR1C': threeAoneC,
    '3AW1AR2C': threeAoneC,
    '3AW1AR3C': threeAoneC,
    '3AW2AR0C': threeA,
    '3AW2AR1C': threeAoneC,
    '3AW2AR2C': threeAoneC,
    '3AW2AR3C': threeAoneC,
    '3AW3AR0C': threeA,
    '3AW3AR1C': threeAoneC,
    '3AW3AR2C': threeAoneC,
    '3AW3AR3C': threeAoneC,
  };

  // Info Modals in the label
  const modalBtns = document.querySelectorAll<HTMLButtonElement>('.open-modal-window');
  modalBtns.forEach((modalBtn) => {
    modalBtn.addEventListener('click', () => {
      const modalId = modalBtn.getAttribute('data-modal-id');
      if (modalId) {
        const modalItem = document.getElementById(modalId);
        if (modalItem) {
          modalItem.classList.add('active');
        }
      }
    });
  });

  const modalBtnClose = document.querySelectorAll<HTMLButtonElement>('.close-modal-window');
  modalBtnClose.forEach((closeBtn) => {
    closeBtn.addEventListener('click', () => {
      const modalItem = closeBtn.closest('.modal-window');
      if (modalItem) {
        modalItem.classList.remove('active');
      }
    });
  });

  // Slider range
  const range = document.querySelector<HTMLInputElement>('.modal--affordability__range');
  const bubble = document.querySelector<HTMLOutputElement>('.bubble ');

  if (range && bubble) {
    range.addEventListener('input', () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);
  }
  function setBubble(range: HTMLInputElement, bubble: HTMLOutputElement) {
    const val = range.value;
    const min = range.min ? parseFloat(range.min) : 0;
    const max = range.max ? parseFloat(range.max) : 40;
    const newVal = Number(((parseFloat(val) - min) * 100) / (max - min));
    bubble.innerHTML = val + ' Years';
    bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    formValue.MortgageTerm = val;
  }
  function updateNetIncome(): void {
    const inpNetIncomeA1: HTMLInputElement | null = document.querySelector('#inpNetIncomeA1');
    const inpNetIncomeA2: HTMLInputElement | null = document.querySelector('#inpNetIncomeA2');
    const inpNetIncomeA3: HTMLInputElement | null = document.querySelector('#inpNetIncomeA3');
    const inpNetIncomeA4: HTMLInputElement | null = document.querySelector('#inpNetIncomeA4');
    const inpNetIncomeA1YM: HTMLInputElement | null = document.querySelector('#inpNetIncomeA1YM');
    const inpNetIncomeA2YM: HTMLInputElement | null = document.querySelector('#inpNetIncomeA2YM');
    const inpNetIncomeA3YM: HTMLInputElement | null = document.querySelector('#inpNetIncomeA3YM');
    const inpNetIncomeA4YM: HTMLInputElement | null = document.querySelector('#inpNetIncomeA4YM');
    if (
      !inpNetIncomeA1 ||
      !inpNetIncomeA2 ||
      !inpNetIncomeA3 ||
      !inpNetIncomeA4 ||
      !inpNetIncomeA1YM ||
      !inpNetIncomeA2YM ||
      !inpNetIncomeA3YM ||
      !inpNetIncomeA4YM
    ) {
      console.error('One or more input elements not found!');
      return;
    }
    let incomeA1: number = parseFloat(inpNetIncomeA1.value) || 0;
    let incomeA2: number = parseFloat(inpNetIncomeA2.value) || 0;
    let incomeA3: number = parseFloat(inpNetIncomeA3.value) || 0;
    let incomeA4: number = parseFloat(inpNetIncomeA4.value) || 0;
    const incomeA1YM: string = inpNetIncomeA1YM.value;
    const incomeA2YM: string = inpNetIncomeA2YM.value;
    const incomeA3YM: string = inpNetIncomeA3YM.value;
    const incomeA4YM: string = inpNetIncomeA4YM.value;
    if (incomeA1YM === 'm') {
      incomeA1 *= 12;
    }
    if (incomeA2YM === 'm') {
      incomeA2 *= 12;
    }
    if (incomeA3YM === 'm') {
      incomeA3 *= 12;
    }
    if (incomeA4YM === 'm') {
      incomeA4 *= 12;
    }
    const totalIncome: number = incomeA1 + incomeA2 + incomeA3 + incomeA4;
    formValue.NetIncomeApplicant1PY = incomeA1.toString();
    formValue.NetIncomeApplicant2PY = incomeA2.toString();
    formValue.NetIncomeApplicant3PY = incomeA3.toString();
    formValue.NetIncomeApplicant4PY = incomeA4.toString();
    formValue.TotalIncomePerYear = totalIncome.toString();
  }
  function updateGrossIncome(): void {
    const inpGrossIncomeA1: HTMLInputElement | null = document.querySelector('#inpGrossIncomeA1');
    const inpGrossIncomeA2: HTMLInputElement | null = document.querySelector('#inpGrossIncomeA2');
    const inpGrossIncomeA3: HTMLInputElement | null = document.querySelector('#inpGrossIncomeA3');
    const inpGrossIncomeA4: HTMLInputElement | null = document.querySelector('#inpGrossIncomeA4');
    const inpGrossIncomeA1YM: HTMLInputElement | null = document.querySelector('#inpGrossIncomeA1YM');
    const inpGrossIncomeA2YM: HTMLInputElement | null = document.querySelector('#inpGrossIncomeA2YM');
    const inpGrossIncomeA3YM: HTMLInputElement | null = document.querySelector('#inpGrossIncomeA3YM');
    const inpGrossIncomeA4YM: HTMLInputElement | null = document.querySelector('#inpGrossIncomeA4YM');

    if (
      !inpGrossIncomeA1 ||
      !inpGrossIncomeA2 ||
      !inpGrossIncomeA3 ||
      !inpGrossIncomeA4 ||
      !inpGrossIncomeA1YM ||
      !inpGrossIncomeA2YM ||
      !inpGrossIncomeA3YM ||
      !inpGrossIncomeA4YM
    ) {
      console.error('One or more input elements not found!');
      return;
    }

    let incomeA1: number = parseFloat(inpGrossIncomeA1.value) || 0;
    let incomeA2: number = parseFloat(inpGrossIncomeA2.value) || 0;
    let incomeA3: number = parseFloat(inpGrossIncomeA3.value) || 0;
    let incomeA4: number = parseFloat(inpGrossIncomeA4.value) || 0;
    const incomeA1YM: string = inpGrossIncomeA1YM.value;
    const incomeA2YM: string = inpGrossIncomeA2YM.value;
    const incomeA3YM: string = inpGrossIncomeA3YM.value;
    const incomeA4YM: string = inpGrossIncomeA4YM.value;

    if (incomeA1YM === 'm') {
      incomeA1 *= 12;
    }
    if (incomeA2YM === 'm') {
      incomeA2 *= 12;
    }
    if (incomeA3YM === 'm') {
      incomeA3 *= 12;
    }
    if (incomeA4YM === 'm') {
      incomeA4 *= 12;
    }

    const totalIncome: number = incomeA1 + incomeA2 + incomeA3 + incomeA4;

    // Assuming formValue is defined somewhere in your code
    formValue.GrossIncomeApplicant1PY = incomeA1.toString();
    formValue.GrossIncomeApplicant2PY = incomeA2.toString();
    formValue.GrossIncomeApplicant3PY = incomeA3.toString();
    formValue.GrossIncomeApplicant4PY = incomeA4.toString();
  }

  // Toggle NET income and Gross income according to number of applicants

  document.getElementById('inpNumberOfApplicants')?.addEventListener('change', function () {
    const numberOfApplicants: number = parseFloat(
      (document.getElementById('inpNumberOfApplicants') as HTMLInputElement).value,
    );

    switch (numberOfApplicants) {
      case 1:
        hideApplicantFields(2, 4);
        showApplicantFields(1);
        break;
      case 2:
        hideApplicantFields(3, 4);
        showApplicantFields(1, 2);
        break;
      case 3:
        hideApplicantFields(4);
        showApplicantFields(1, 2, 3);
        break;
      case 4:
        showApplicantFields(1, 2, 3, 4);
        break;
    }

    formValue.NumberOfApplicants = numberOfApplicants;
    updateNetIncome();
    updateGrossIncome();
  });
  hideApplicantFields(2, 4);

  function hideApplicantFields(startIndex: number, endIndex?: number) {
    for (let i = startIndex; i <= (endIndex || startIndex); i++) {
      const netIncomeElem = document.getElementById(`cnNetIncomeA${i}`);
      const grossIncomeElem = document.getElementById(`cnGrossIncomeA${i}`);

      if (netIncomeElem && grossIncomeElem) {
        netIncomeElem.style.display = 'none';
        grossIncomeElem.style.display = 'none';

        // Disable input fields and select elements
        netIncomeElem.querySelectorAll('input, select').forEach((element: Element) => {
          if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
            element.disabled = true;
          }
        });
        grossIncomeElem.querySelectorAll('input, select').forEach((element: Element) => {
          if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
            element.disabled = true;
          }
        });
      }
    }
  }

  function showApplicantFields(...indices: number[]) {
    indices.forEach((index) => {
      const netIncomeElem = document.getElementById(`cnNetIncomeA${index}`);
      const grossIncomeElem = document.getElementById(`cnGrossIncomeA${index}`);

      if (netIncomeElem && grossIncomeElem) {
        netIncomeElem.style.display = 'block';
        grossIncomeElem.style.display = 'block';

        // Enable input fields and select elements
        netIncomeElem.querySelectorAll('input, select').forEach((element: Element) => {
          if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
            element.disabled = false;
          }
        });
        grossIncomeElem.querySelectorAll('input, select').forEach((element: Element) => {
          if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
            element.disabled = false;
          }
        });
      }
    });
  }

  // Update Net Income
  (document.getElementById('inpNetIncomeA1') as HTMLInputElement)?.addEventListener('keyup', function () {
    const inputElement = this as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    updateNetIncome();
  });

  (document.getElementById('inpNetIncomeA2') as HTMLInputElement)?.addEventListener('keyup', function () {
    const inputElement = this as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    updateNetIncome();
  });

  (document.getElementById('inpNetIncomeA3') as HTMLInputElement)?.addEventListener('keyup', function () {
    const inputElement = this as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    updateNetIncome();
  });

  (document.getElementById('inpNetIncomeA4') as HTMLInputElement)?.addEventListener('keyup', function () {
    const inputElement = this as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    updateNetIncome();
  });

  (document.getElementById('inpNetIncomeA1YM') as HTMLSelectElement)?.addEventListener('change', function () {
    updateNetIncome();
  });

  (document.getElementById('inpNetIncomeA2YM') as HTMLSelectElement)?.addEventListener('change', function () {
    updateNetIncome();
  });

  (document.getElementById('inpNetIncomeA3YM') as HTMLSelectElement)?.addEventListener('change', function () {
    updateNetIncome();
  });

  (document.getElementById('inpNetIncomeA4YM') as HTMLSelectElement)?.addEventListener('change', function () {
    updateNetIncome();
  });

  // Update Gross Income
  (document.getElementById('inpGrossIncomeA1') as HTMLInputElement)?.addEventListener('keyup', function () {
    const inputElement = this as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    updateGrossIncome();
  });

  (document.getElementById('inpGrossIncomeA2') as HTMLInputElement)?.addEventListener('keyup', function () {
    const inputElement = this as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    updateGrossIncome();
  });

  (document.getElementById('inpGrossIncomeA3') as HTMLInputElement)?.addEventListener('keyup', function () {
    const inputElement = this as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    updateGrossIncome();
  });

  (document.getElementById('inpGrossIncomeA4') as HTMLInputElement)?.addEventListener('keyup', function () {
    const inputElement = this as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    updateGrossIncome();
  });

  (document.getElementById('inpGrossIncomeA1YM') as HTMLSelectElement)?.addEventListener('change', function () {
    updateGrossIncome();
  });

  (document.getElementById('inpGrossIncomeA2YM') as HTMLSelectElement)?.addEventListener('change', function () {
    updateGrossIncome();
  });

  (document.getElementById('inpGrossIncomeA3YM') as HTMLSelectElement)?.addEventListener('change', function () {
    updateGrossIncome();
  });

  (document.getElementById('inpGrossIncomeA4YM') as HTMLSelectElement)?.addEventListener('change', function () {
    updateGrossIncome();
  });

  // Update Household Expenditure
  (document.getElementById('formInput_expenditureA1') as HTMLInputElement)?.addEventListener('keyup', function () {
    const inputElement = this as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

    const expenditureA1: number = parseFloat(inputElement.value) || 0;
    const expenditureA1YM: string | null = (document.getElementById('formInput_expenditureA1YM') as HTMLSelectElement)
      ?.value;

    let totalExpenditure: number = expenditureA1;
    if (expenditureA1YM === 'm') {
      totalExpenditure *= 12;
    }

    formValue.HouseholdExpenditurePY = totalExpenditure.toString();
  });

  (document.getElementById('formInput_expenditureA1YM') as HTMLSelectElement)?.addEventListener('change', function () {
    const expenditureA1: number =
      parseFloat((document.getElementById('formInput_expenditureA1') as HTMLInputElement).value) || 0;
    const expenditureA1YM: string | null = (this as HTMLSelectElement).value;

    let totalExpenditure: number = expenditureA1;
    if (expenditureA1YM === 'm') {
      totalExpenditure *= 12;
    }

    formValue.HouseholdExpenditurePY = totalExpenditure.toString();
  });

  // Update Credit Commitments
  (document.getElementById('formInput_creditCommitments') as HTMLInputElement)?.addEventListener('keyup', function () {
    const inputElement = this as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

    const expenditureCC: number = parseFloat(inputElement.value) || 0;
    const creditCommitmentsYM: string | null = (
      document.getElementById('formInput_creditCommitmentsYM') as HTMLSelectElement
    )?.value;

    let totalExpenditureCC: number = expenditureCC;
    if (creditCommitmentsYM === 'm') {
      totalExpenditureCC *= 12;
    }

    formValue.creditCommitmentsPY = totalExpenditureCC.toString();
  });

  (document.getElementById('formInput_creditCommitmentsYM') as HTMLSelectElement)?.addEventListener(
    'change',
    function () {
      const expenditureCC: number =
        parseFloat((document.getElementById('formInput_creditCommitments') as HTMLInputElement).value) || 0;
      const creditCommitmentsYM: string | null = (this as HTMLSelectElement).value;

      let totalExpenditureCC: number = expenditureCC;
      if (creditCommitmentsYM === 'm') {
        totalExpenditureCC *= 12;
      }

      formValue.creditCommitmentsPY = totalExpenditureCC.toString();
    },
  );

  // Update Energy Costs
  (document.getElementById('formInput_energyCosts') as HTMLInputElement)?.addEventListener('keyup', function () {
    const inputElement = this as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

    const energyCostsCC: number = parseFloat(inputElement.value) || 0;
    const energyCostsYM: string | null = (document.getElementById('formInput_energyCostsYM') as HTMLSelectElement)
      ?.value;

    let totalenergyCostsCC: number = energyCostsCC;
    if (energyCostsYM === 'm') {
      totalenergyCostsCC *= 12;
    }

    formValue.energyCostsPY = totalenergyCostsCC.toString();
  });

  (document.getElementById('formInput_energyCostsYM') as HTMLSelectElement)?.addEventListener('change', function () {
    const energyCostsCC: number =
      parseFloat((document.getElementById('formInput_energyCosts') as HTMLInputElement).value) || 0;
    const energyCostsYM: string | null = (this as HTMLSelectElement).value;

    let totalenergyCostsCC: number = energyCostsCC;
    if (energyCostsYM === 'm') {
      totalenergyCostsCC *= 12;
    }

    formValue.energyCostsPY = totalenergyCostsCC.toString();
  });

  // Update Property Purchase Price and Mortgage Amount
  (document.getElementById('inpPropertyPurchasePrice') as HTMLInputElement)?.addEventListener('keyup', function () {
    const inputElement = this as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

    const propertyPurchasePrice: number = parseFloat(inputElement.value) || 0;
    const mortgageAmount: number =
      parseFloat((document.getElementById('inpMortgageAmount') as HTMLInputElement).value) || 0;

    const loanToValue: number = (mortgageAmount / propertyPurchasePrice) * 100;

    formValue.PropertyPurchasePrice = propertyPurchasePrice.toString();
    formValue.MortgageAmount = mortgageAmount.toString();
    formValue.LoanToValue = loanToValue.toString();
  });

  (document.getElementById('inpMortgageAmount') as HTMLInputElement)?.addEventListener('keyup', function () {
    const inputElement = this as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

    const propertyPurchasePrice: number =
      parseFloat((document.getElementById('inpPropertyPurchasePrice') as HTMLInputElement).value) || 0;
    const mortgageAmount: number = parseFloat(inputElement.value) || 0;

    const loanToValue: number = (mortgageAmount / propertyPurchasePrice) * 100;

    formValue.PropertyPurchasePrice = propertyPurchasePrice.toString();
    formValue.MortgageAmount = mortgageAmount.toString();
    formValue.LoanToValue = loanToValue.toString();
  });

  // Update Repayment Type
  (document.getElementById('inpRepaymentType') as HTMLSelectElement)?.addEventListener('change', function () {
    const repaymentType: string = (this as HTMLSelectElement).value;
    formValue.RepaymentType = repaymentType;
  });

  // Update Property Type
  (document.getElementById('inpPropertyType') as HTMLSelectElement)?.addEventListener('change', function () {
    const propertyType: string = (this as HTMLSelectElement).value;
    formValue.PropertyType = propertyType;
  });

  // Select all input elements and bind "keyup" and "change" events
  document.querySelectorAll('input, select').forEach((input) => {
    input.addEventListener('keyup', handleInputChange);
    input.addEventListener('change', handleInputChange);
  });
  var adultsWorking = 0;
  var adultsRetired = 0;
  var children = 0;
  var familyString = '';

  const inpWorkingAdult = document.getElementById('inpWorkingAdult') as HTMLInputElement;
  const inpRetiredAdult = document.getElementById('inpRetiredAdult') as HTMLInputElement;
  const inpChildren = document.getElementById('inpChildren') as HTMLInputElement;

  const updateFamilyStringAndValidate = () => {
    adultsWorking = parseFloat(inpWorkingAdult.value) || 0;
    adultsRetired = parseFloat(inpRetiredAdult.value) || 0;
    children = parseFloat(inpChildren.value) || 0;

    familyString = `${adultsWorking}AW${adultsRetired}AR${children}C`;

    if (familyString.includes('NaN')) {
      return; // Exit if any input is empty or invalid
    }

    if (familyGroups[familyString]) {
      // Valid family string; update form values and UI
      formValue.AdultsWorking = adultsWorking;
      formValue.AdultsRetired = adultsRetired;
      formValue.Children = children;
      formValue.PersonsExpenditurePM = familyGroups[familyString];

      document.querySelector('.sNOA')!.textContent = String(formValue.AdultsWorking);
      document.querySelector('.sNOAR')!.textContent = String(formValue.AdultsRetired);
      document.querySelector('.sNOC')!.textContent = String(formValue.Children);
    } else {
      // Invalid family string; alert and clear invalid field
      alert('Sorry, this is not a valid selection');
      if (!adultsWorking) inpWorkingAdult.value = '';
      if (!adultsRetired) inpRetiredAdult.value = '';
      if (!children) inpChildren.value = '';
    }
  };

  inpWorkingAdult.addEventListener('input', updateFamilyStringAndValidate);
  inpRetiredAdult.addEventListener('input', updateFamilyStringAndValidate);
  inpChildren.addEventListener('input', updateFamilyStringAndValidate);

  function handleInputChange(e: Event) {
    const energyCostPY: number =
      typeof formValue.energyCostsPY === 'string' ? parseFloat(formValue.energyCostsPY) : formValue.energyCostsPY || 0;

    const energyCostPM: number = energyCostPY / 12;
    var EnergyCost: number;

    switch (formValue.PropertyType) {
      case 'detached':
        EnergyCost = Math.max(energyCostPM, parseFloat(onsdetached));
        break;
      case 'semi':
        EnergyCost = Math.max(energyCostPM, parseFloat(onssemi));
        break;
      case 'end':
        EnergyCost = Math.max(energyCostPM, parseFloat(onsend));
        break;
      case 'mid':
        EnergyCost = Math.max(energyCostPM, parseFloat(onsmid));
        break;
      case 'bungalow':
        EnergyCost = Math.max(energyCostPM, parseFloat(onsbungalow));
        break;
      case 'flat':
        EnergyCost = Math.max(energyCostPM, parseFloat(onsflat));
        break;
      default:
        EnergyCost = energyCostPM;
    }
    var MonthlyDispensibleIncome =
      (parseFloat(formValue.TotalIncomePerYear.toString()) -
        (parseFloat(formValue.HouseholdExpenditurePY.toString()) +
          parseFloat(formValue.creditCommitmentsPY.toString()) +
          parseFloat(formValue?.PersonsExpenditurePM?.toString()) * 12 +
          EnergyCost * 12)) /
      12;
    var CombinedGrossIncome =
      parseFloat(formValue.GrossIncomeApplicant1PY.toString()) +
      (parseFloat(formValue.GrossIncomeApplicant2PY.toString()) +
        (parseFloat(formValue.GrossIncomeApplicant3PY.toString()) +
          parseFloat(formValue.GrossIncomeApplicant4PY.toString())));
    formValue.MonthlyDispensibleIncome = MonthlyDispensibleIncome;
    var StressRate = 7.89; // Stress rate
    var sr = StressRate / 12 / 100;
    var n = parseFloat(formValue.MortgageTerm.toString()) * 12;

    var p = parseFloat(formValue.MortgageAmount.toString());
    var sp = p * 0.5;
    var m = parseFloat(formValue.MonthlyDispensibleIncome.toString());
    var sm = m + m * 0.1;

    var IncomeMultiple: number = 0;
    var MaxLoan = 0;
    var GrossMaxLoan = 0;
    var RepaymentTypeText: string = '';
    // Changed to reflect 4.49 as the income multiplier 08/2026
    switch (formValue.NumberOfApplicants) {
      case 1:
        IncomeMultiple = 4.49;
        GrossMaxLoan = CombinedGrossIncome * IncomeMultiple;
        break;
      case 2:
        IncomeMultiple = 4.49;
        GrossMaxLoan = CombinedGrossIncome * IncomeMultiple;
        break;
      case 3:
        IncomeMultiple = 4.49;
        GrossMaxLoan = CombinedGrossIncome * IncomeMultiple;
        break;
      case 4:
        IncomeMultiple = 4.49;
        GrossMaxLoan = CombinedGrossIncome * IncomeMultiple;
        break;
    }
    formValue.IncomeMultiple = IncomeMultiple;

    switch (formValue.RepaymentType) {
      case 'c':
        MaxLoan = Math.floor((m / sr) * (1 - 1 / Math.pow(1 + sr, n)));
        RepaymentTypeText = 'Capital & Interest';
        break;
      case 'i':
        MaxLoan = (12 * m) / (sr * 12);
        RepaymentTypeText = 'Interest Only';
        break;
      case '0':
        MaxLoan = 0;
        RepaymentTypeText = 'x';
        break;
    }
    var LowestMaxLoan = GrossMaxLoan;
    if (MaxLoan < GrossMaxLoan) {
      LowestMaxLoan = MaxLoan;
    }
    var Statement =
      'This enquiry passes our automated check for the loan size requested. Based on the income and expenditure you have input, the maximum loan size would be £' +
      LowestMaxLoan.toFixed(2) +
      ', subject to lending criteria and loan to value eligibility.  Please call an Underwriter on 01257 235001 to discuss your specific case or email intermediaries@chorleybs.co.uk or you can send us a request for a Decision in Principle. Details of how to do this can be found in the How to Apply section.';
    var HardFail = 0;
    var SoftFail = 0;
    var OverOM = 0;
    if (p > 1400000) {
      SoftFail = 1;
      Statement =
        'For loans over £1.4m please call an Underwriter on 01257 235001 to discuss your specific case or email intermediaries@chorleybs.co.uk.';
      OverOM = 1;
    }
    var eligibility = parseFloat(((LowestMaxLoan / p) * 100).toFixed(1));
    if (eligibility > 100) {
      eligibility = 100;
    }
    if (MaxLoan < sp) {
      HardFail = 1;
    } else if (MaxLoan < p) {
      SoftFail = 1;
    }

    if (GrossMaxLoan < sp) {
      HardFail = 1;
    } else if (GrossMaxLoan < p) {
      SoftFail = 1;
    }
    if (OverOM == 0) {
      if (HardFail == 1) {
        Statement =
          'Based on the income and expenditure you have input, the maximum loan size would be £' +
          LowestMaxLoan.toFixed(2) +
          ". This does not appear to meet your customer's requirements, please call an Underwriter on 01257 235001 to discuss your specific case or email intermediaries@chorleybs.co.uk.";
      }
      if (SoftFail == 1) {
        Statement =
          'Based on the income and expenditure you have input, the maximum loan size would be £' +
          LowestMaxLoan.toFixed(2) +
          ". This does not appear to meet your customer's requirements, please call an Underwriter on 01257 235001 to discuss your specific case or email intermediaries@chorleybs.co.uk.";
      }
      if (formValue.RepaymentType == 'i') {
        if (p > 999999999) {
          Statement =
            'Unfortunately we do not provide Interest Only Mortgages over the value of £500,000. Please call an Underwriter on 01257 235001 to discuss your specific case or email intermediaries@chorleybs.co.uk.';
        }
      }
    }
    if (p < 50000) {
      Statement =
        'Based on the income and expenditure you have input, this does not meet our minimum loan requirements of £50,000. Please call an Underwriter on 01257 235001 to discuss your specific case or email intermediaries@chorleybs.co.uk.';
    }
    if (GrossMaxLoan < 50000) {
      Statement =
        'Based on the income and expenditure you have input, the maximum loan size would be £' +
        LowestMaxLoan.toFixed(2) +
        '. This does not meet our minimum loan requirements of £50,000. Please call an Underwriter on 01257 235001 to discuss your specific case or email intermediaries@chorleybs.co.uk.';
    }

    const sBQOL = document.querySelector('.sBQOL');
    const sHBE = document.querySelector('.sHBE');
    const sTCOL = document.querySelector('.sTCOL');
    const sCNI = document.querySelector('.sCNI');
    const sMDI = document.querySelector('.sMDI');
    const sML = document.querySelector('.sML');
    const sMLG = document.querySelector('.sMLG');
    const sSR = document.querySelector('.sSR');
    const sRT = document.querySelector('.sRT');
    const sIM = document.querySelector('.sIM');
    const sCGI = document.querySelector('.sCGI');
    const sMT = document.querySelector('.sMT');
    const sIR = document.querySelector('.sIR');
    const sMA = document.querySelector('.sMA');
    const sLML = document.querySelector('.sLML');
    const sStmt = document.querySelector('.sStmt');
    const sMCC = document.querySelector('.sMCC');
    const sMEC = document.querySelector('.sMEC');

    if (sBQOL) sBQOL.textContent = formValue?.PersonsExpenditurePM?.toString() + '.';

    if (sHBE) sHBE.textContent = (parseFloat(formValue.HouseholdExpenditurePY.toString()) / 12).toFixed(2);
    let combinedExpenditure: number =
      parseFloat(formValue.HouseholdExpenditurePY.toString()) / 12 +
      parseFloat(formValue?.PersonsExpenditurePM?.toString()) +
      parseFloat(formValue.creditCommitmentsPY.toString()) / 12 +
      EnergyCost;
    if (sTCOL) sTCOL.textContent = combinedExpenditure.toFixed(2);
    if (sCNI) sCNI.textContent = parseFloat(String(Number(formValue.TotalIncomePerYear) / 12)).toFixed(2);
    if (sMDI) sMDI.textContent = parseFloat(String(formValue.MonthlyDispensibleIncome)).toFixed(2) + '.';
    if (sML) sML.textContent = parseFloat(String(MaxLoan)).toFixed(2);
    if (sMLG) sMLG.textContent = String(GrossMaxLoan);
    if (sSR) sSR.textContent = StressRate.toFixed(2);
    if (sRT) sRT.textContent = RepaymentTypeText;
    if (sIM) sIM.textContent = String(formValue.IncomeMultiple);
    if (sCGI) sCGI.textContent = parseFloat(String(CombinedGrossIncome)).toFixed(2);
    if (sMT) sMT.textContent = formValue.MortgageTerm.toString();
    if (sIR) sIR.textContent = formValue.InterestRate.toString();
    if (sMA) sMA.textContent = formValue.MortgageAmount.toString();
    if (sLML) sLML.textContent = String(parseInt(LowestMaxLoan.toString()));
    if (sStmt) sStmt.textContent = Statement;
    if (sMCC) {
      const creditCommitmentsPYValue = parseFloat(formValue.creditCommitmentsPY.toString());
      if (!isNaN(creditCommitmentsPYValue)) {
        sMCC.textContent = String(creditCommitmentsPYValue / 12);
      } else {
        console.error('Invalid creditCommitmentsPY value:', formValue.creditCommitmentsPY);
      }
    }

    if (sMEC) sMEC.textContent = String(EnergyCost) + '.';
  }

  const form = document.getElementById('form');

  form?.addEventListener('submit', function (e) {
    e.preventDefault();

    form.style.display = 'none';
    const summaryRow = document.getElementById('summaryRow');
    if (summaryRow) {
      summaryRow.style.display = 'block';
    }
    return false;
  });

  const backToFormBtn = document.getElementById('close-summary');
  if (form) {
    backToFormBtn?.addEventListener('click', function () {
      form.style.display = 'block';
      const summaryRow = document.getElementById('summaryRow');
      if (summaryRow) {
        summaryRow.style.display = 'none';
      }
      var resetForm = <HTMLFormElement>document.getElementById('form');
      resetForm?.reset();
      const numberOfApplicants = document.getElementById('inpNumberOfApplicants') as HTMLSelectElement;
      if (numberOfApplicants) {
        numberOfApplicants.value = '1';
        numberOfApplicants.dispatchEvent(new Event('change'));
      }
    });
  }
});
document.addEventListener('wheel', function (e) {
  const target = e.target as HTMLInputElement;
  if (target && target.type === 'number') {
    target.blur();
  }
});

const calcCloseBtn = document.getElementById('btn--close');
calcCloseBtn?.addEventListener('click', function () {
  const form = document.getElementById('myForm') as HTMLFormElement;
  form.reset();
});
